var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrosoftIcon16P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_492_190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_492_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H8.11905V8.11905H0.5V0.5Z",
    fill: "#F35325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88086 0.5H16.4999V8.11905H8.88086V0.5Z",
    fill: "#81BC06"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8.88086H8.11905V16.4999H0.5V8.88086Z",
    fill: "#05A6F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.88086 8.88086H16.4999V16.4999H8.88086V8.88086Z",
    fill: "#FFBA08"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftIcon16P);
export default __webpack_public_path__ + "static/media/microsoft-icon-16p.f79560ea68741929faefe235147846bc.svg";
export { ForwardRef as ReactComponent };